/** 问卷题目API */
import type { Api } from '@/typings/api';
import { post } from '../../request';
const prefix = '/st/stSurveyQuestion';
/**
 * 分页查询问卷题目
 *
 * @param params 查询参数
 */
export const findPage: Api.CommonMethods.FindPage<Api.St.StSurveyQuestion> = params => {
  return post(`${prefix}/findPage`, params);
};
/**
 * 查询问卷题目列表
 *
 * @param params 查询参数
 */
export const findAll: Api.CommonMethods.FindAll<Api.St.StSurveyQuestion> = params => {
  return post(`${prefix}/findAll`, params);
};
/**
 * 查询单个问卷题目
 *
 * @param id 问卷题目ID
 * @param column 查询字段
 */
export const findOne: Api.CommonMethods.FindOne<Api.St.StSurveyQuestion> = (id: string, column?: string[]) => {
  return post(`${prefix}/findOne`, { id, column });
};
/**
 * 保存问卷题目
 *
 * @param params 问卷题目信息
 */
export const doSave: Api.CommonMethods.Save = params => {
  return post(`${prefix}/save`, params);
};
/**
 * 更新问卷题目信息
 *
 * @param params 问卷题目信息
 */
export const doUpdate: Api.CommonMethods.Update = params => {
  return post(`${prefix}/update`, params);
};
/**
 * 删除问卷题目
 *
 * @param id 问卷题目ID
 */
export const doDelete: Api.CommonMethods.Delete = id => {
  return post(`${prefix}/delete?id=${id}`);
};
/**
 * 批量删除问卷题目
 *
 * @param ids 问卷题目ID数组
 */
export const doBatchDelete: Api.CommonMethods.BatchDelete = ids => {
  return post(`${prefix}/deleteList`, { ids });
};

export default {
  findPage,
  findOne,
  doSave,
  doUpdate,
  doDelete,
  doBatchDelete
};
